import { from, Observable } from 'rxjs';
import Swal, { SweetAlertOptions, SweetAlertResult } from 'sweetalert2';
import { GlobalSettings } from '../../../../../_shared/model/utils/global-settings.model';

export class TermsAndConditionsAlertHandler {
    public showTermsAndConditions(settings: GlobalSettings): Observable<SweetAlertResult<unknown>> {
        const options: SweetAlertOptions = {
            title: 'Pogoji uporabe',
            html: `
            Za uporabo aplikacije eAmbulanta se morate strinjati s <a href="${
                settings?.url || 'https://www.medifit.si'
            }" class="m-link" target="blank_">Splošnimi pogoji<i class="la la-external-link"></i></a>
            in <a href="${
                settings?.privacyPolicyUrl || 'https://www.medifit.si'
            }" class="m-link" target="blank_">Politiko zasebnosti<i class="la la-external-link"></i></a>.
          `,
            input: 'checkbox',
            inputPlaceholder: 'Strinjam se z zgoraj navedenimi dokumenti.',
            confirmButtonText: 'Začnite z uporabo',
            cancelButtonText: 'Prekliči',
            inputValidator: result => {
                return !result && 'Za uporabo programa se morate strinjati s pogoji uporabe.';
            },
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success m-btn m-btn--custom m-btn--pill',
            confirmButtonColor: null,
            cancelButtonClass: 'btn btn-secondary m-btn m-btn--custom m-btn--pill',
            cancelButtonColor: null,
            allowOutsideClick: false,
            allowEscapeKey: false,
        } as SweetAlertOptions;

        return from(Swal.fire(options));
    }

    public showNewReleaseInfo(settings: GlobalSettings): Observable<SweetAlertResult<unknown>> {
        const updateText = settings?.newRelease?.description?.replace(/\n/g, `<br />`);
        const options: SweetAlertOptions = {
            title: settings?.newRelease?.title,
            html: `
            ${updateText}
            <br />
            <a href="${settings?.newRelease?.url}" class="m-link text-center" target="blank_">Podrobnosti<i class="la la-external-link"></i></a>.
          `,
            type: 'info',
            showCancelButton: false,
            inputPlaceholder: 'Strinjam se z zgoraj navedenimi dokumenti.',
            confirmButtonText: 'OK',
            cancelButtonText: 'Prekliči',
            inputValidator: result => {
                return !result && 'Za uporabo programa se morate strinjati s pogoji uporabe.';
            },
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success m-btn m-btn--custom m-btn--pill',
            customClass: {
                content: 'mf-swal-content',
            },
        } as SweetAlertOptions;

        return from(Swal.fire(options));
    }
}
